require.config({
	baseUrl: "/resources/𝓥𝓔𝓡𝓢𝓘𝓞𝓝/",
	paths: {
		"hypo_bvo": "_assets/hypo-bvo/JavaScript/Bvo",
		"hypo_elements": "_assets/hypo-elements/JavaScript",
		"@drklein/client-detection": "vendor/@drklein/client-detection/dist/index",
		"@drklein/touch-detection": "vendor/@drklein/client-detection/dist/touch-detection",
		"@drklein/mobile-detection": "vendor/@drklein/client-detection/dist/mobile-detection",
		"@drklein/browser-detection": "vendor/@drklein/client-detection/dist/browser-detection",
		"@drklein/form-element": "vendor/@drklein/form-element",
		"@drklein/locale-formatter": "vendor/@drklein/locale-formatter/dist/locale-formatter",

		// External dependencies
		"@sentry/browser": "vendor/@sentry/browser/build/bundle.min",
		"async": "vendor/requirejs-plugins/src/async",
		"jquery": "vendor/jquery/dist/jquery.min",
		"jquery-ui": "vendor/jquery-ui/jquery-ui.min",
		"jquery-ui/ui": "vendor/jquery-ui/ui",
		"bootstrap": "vendor/bootstrap-sass/assets/javascripts/bootstrap.min",
		"mustache": "vendor/mustache/mustache.min",
		"hammerjs": "vendor/hammerjs/hammer.min",
		"iframe-resizer": "vendor/iframe-resizer/js/iframeResizer.min",
		"js-cookie": "vendor/js-cookie/src/js.cookie",
		"jquery-countto": "vendor/jquery-countto/jquery.countTo",
		"jquery-waypoints": "vendor/waypoints/lib/jquery.waypoints.min",
		"angular": "vendor/angular/angular.min",
		"angular-route": "vendor/angular-route/angular-route.min",
		"angular-i18n": "vendor/angular-i18n/angular-locale_de",
		"chartjs-4": "vendor/chartjs-4/dist/chart.umd",
		"chartjs-adapter-moment-fix": "_assets/hypo-elements/Vendor/chartjs-adapter-moment-fix/chartjs-adapter-moment.min",
		"devextreme": "vendor/devextreme/dist/js/dx.all",
		"moment": "vendor/moment/min/moment.min",
		"moment-fix": "_assets/hypo-elements/JavaScript/Typescripts/Main/MomentFix",
		"webfontloader": "vendor/webfontloader/webfontloader",
		"word-counter": "_assets/hypo-elements/JavaScript/Typescripts/WordCounter/WordCounter",
		"social-share": "_assets/hypo-elements/JavaScript/Elements/SocialShare/SocialShare",
		"libphonenumber-js": "vendor/libphonenumber-js/bundle/libphonenumber-js.min",
		"leadid-reader": "_assets/hypo-elements/JavaScript/Elements/LeadidReader/LeadidReader",
		"swiper": "vendor/swiper/swiper-bundle.min",
		"glightbox": "vendor/glightbox/dist/js/glightbox.min",
		"lazysizes": "vendor/lazysizes/lazysizes.min",
        "zonejs": "vendor/zone.js/bundles/zone.umd.min",

		// AngularJS apps
		"zinstableauApp": "https://www.drklein.de/apps/zinstableau/js/zinstableau.min",
		"ratenkreditrechnerApp": "apps/ratenkreditrechner/js/ratenkreditrechner.min",

		"kreditrechner": "apps/drklein/kreditrechner/drk-kreditrechner",
		"baufinanzierungAntragDrklein": "apps/baufinanzierung-antrag-drklein",
		"mietkaufrechnerapp": "apps/miet-kauf-rechner-2020/bootstrap-angular-app",

		// Formi apps
		"formi-fix": "_assets/hypo-elements/JavaScript/Typescripts/Main/FormiFix"
	},

	map: {
		"*": {
			"configuration": "hypo_elements/Typescripts/Configuration/Configuration",
			"devextreme/dist/ts/dx.all": "vendor/devextreme/dist/js/dx.viz"
		},
	},

	shim: {
		"@sentry/browser": {
			exports: "Sentry",
		},

		"jquery-waypoints": {
			deps: ["jquery"],
			exports: "window.Waypoint",
		},

		"@drklein/form-element/form-element": {
			deps: [
				"jquery-ui",
				"jquery-ui/ui/i18n/datepicker-de",
			],
		},

		"vendor/jquery-ui/ui/i18n/datepicker-de": {
			deps: [
				"jquery-ui/ui/widgets/datepicker",
			],
		},

		"bootstrap": {
			deps: ["jquery"],
			exports: "$.fn.modal",
		},

		"angular": {
			exports: "window.angular",
		},

		"angular-route": {
			deps: ["angular"],
		},

		"angular-i18n": {
			deps: ["angular"],
		},

		"zinstableauApp": {
			deps: [
				"angular",
				"angular-route",
				"angular-i18n",
			],
		},

		"ratenkreditrechnerApp": {
			deps: [
				"angular",
				"angular-route",
				"angular-i18n",
			],
		},

		"mietkaufrechnerapp": {
			deps: ["zonejs"],
		},

		"baufinanzierungAntragDrklein/polyfills": {
			deps: ["baufinanzierungAntragDrklein/runtime"],
		},

		"baufinanzierungAntragDrklein/main": {
			deps: ["baufinanzierungAntragDrklein/polyfills"],
		},

		"/apps/formi/baufidrk01/formi.min.js": {
			deps: [
				"formi-fix",
				"moment-fix",
			],
		},

		"/apps/formi/baufidrk02/formi.min.js": {
			deps: [
				"formi-fix",
				"moment-fix",
			],
		},

		"/apps/formi/ratenkreditdrk01/formi.min.js": {
			deps: [
				"formi-fix",
				"moment-fix",
			],
		},
	},

	waitSeconds: 0, // no timeout
	enforceDefine: false,

});

require(['jquery'], function ($) {
	require(['hypo_elements/Typescripts/require-initial-dependencies-built']);
});
